import {
  FETCHING_USERS_REQUEST,
  FETCHING_USERS_SUCCEDDED,
  FETCHING_USERS_FAILED,
  INVALIDATE_USERS,
  FETCHING_INVITATIONS_REQUEST,
  FETCHING_INVITATIONS_SUCCEDDED,
  FETCHING_INVITATIONS_FAILED,
  INVITE_USER_REQUEST,
  INIVITE_USER_SUCCEDDED,
  INIVITE_USER_FAILED,
  INVALIDATE_ERROR_MESSAGE,
  SELECT_USER,
  INVALIDATE_USER,
  UPDATE_USER_ACTIVATION,
  UPDATE_USER_ACTIVATION_SUCCEDDED,
  UPDATE_USER_ACTIVATION_FAILED,
  UPDATE_USER_ACCESS,
  UPDATE_USER_ACCESS_SUCCEEDED,
  UPDATE_USER_ACCESS_FAILED,
  RESEND_USER_INVITATION,
  RESEND_USER_INVITATION_SUCCEDDED,
  RESEND_USER_INVITATION_FAILED,
  DELETE_USER_INVITATION,
  DELETE_USER_INVITATION_SUCCEDDED,
  DELETE_USER_INVITATION_FAILED,
  FETCHING_USER_MANAGEMENT_LIST_REQUEST,
  FETCHING_USER_MANAGEMENT_LIST_SUCCEEDED,
  FETCHING_USER_MANAGEMENT_LIST_FAILED,
  INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_REQUEST,
  INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_SUCCEDDED,
  INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_FAILED,
  FETCHING_USER_MANAGEMENT_USER_REQUEST,
  FETCHING_USER_MANAGEMENT_USER_SUCCEEDED,
  FETCHING_USER_MANAGEMENT_USER_FAILED,
  FETCHING_USER_GROUPS_FOR_USER_REQUEST,
  FETCHING_USER_GROUPS_FOR_USER_SUCCEEDED,
  FETCHING_USER_GROUPS_FOR_USER_FAILED,
  INVALIDATE_USER_GROUPS,
  UPDATE_USER_ROLES,
  UPDATE_USER_ROLES_SUCCEEDED,
  UPDATE_USER_ROLES_FAILED,
} from "../actions/actionTypes.jsx";

var paginationState = {
  currentPage: 0,
  totalPages: 0,
  recordsPerPage: 50,
  totalRecordsCount: 0,
};

const initialState = {
  error: {},
  sending: false,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1,
  },
  download: {
    downloading: false,
    invalidated: true,
    downloaded: false,
    items: [],
    pagination: {
      ...paginationState,
    },
    error: null,
  },
  users: {
    loading: false,
    invalidated: true,
    items: [],
    user: {},
    pagination: {
      current: -1,
      totalPages: 1,
    },
    deleting: false,
    updatingAccess: false,
    updating: false,
  },
  invitations: {
    loading: false,
    invalidated: true,
    items: [],
    invitation: {},
    pagination: {
      current: -1,
      totalPages: 1,
    },
    deleting: false,
    updating: false,
  },
  userGroups: {
    loading: false,
    invalidated: true,
    items: [],
    pagination: {
      current: -1,
      totalPages: 1,
    },
  },
};

function userManagementReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_USER_MANAGEMENT_LIST_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true,
      });
    case FETCHING_USER_MANAGEMENT_LIST_SUCCEEDED:
      var records = action.payload.records;
      var items = [];
      if (action.payload.currentPage == 0) {
        items = action.payload.records;
      } else {
        items = [...state.items, ...action.payload.records];
      }

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);


      // sort based on score, name
      const sortedArr = items.sort((a, b) => {
        // Compare by score first
        let scoreComparison = a.score - b.score;
        if (scoreComparison !== 0) {
            return scoreComparison;
        }
        // If scores are equal, compare by name (case insensitive)
        let nameA = a.name.toLowerCase();
        let nameB = b.name.toLowerCase();
        
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        // Names are equal
        return 0;
    });


      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        items: sortedArr,
        pagination: {
          ...state.pagination,
          current: action.payload.currentPage,
          totalPages: action.payload.totalPages,
        },
      });
    case FETCHING_USER_MANAGEMENT_LIST_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error,
      });
    case INVALIDATE_USERS:
      return Object.assign({}, state, {
        ...state,
        users: {
          loading: false,
          invalidated: true,
          items: [],
          pagination: {
            current: -1,
            totalPages: 1,
          },
        },
      });
    case FETCHING_USERS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          loading: true,
          invalidated: true,
        },
      });
    case FETCHING_USERS_SUCCEDDED:
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage != 0) {
        items = [...state.users.items, ...action.payload.records];
      } else {
        items = action.payload.records;
      }

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          loading: false,
          invalidated: false,
          items: items,
          pagination: {
            ...state.users.pagination,
            current: action.payload.currentPage,
            totalPages: action.payload.totalPages,
          },
        },
      });
    case FETCHING_USERS_FAILED:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          loading: false,
          invalidated: false,
          error: action.payload.error,
          pagination: {
            current: -1,
            totalPages: 1,
          },
        },
      });
    case INVALIDATE_USERS:
      return Object.assign({}, state, {
        ...state,
        users: {
          loading: false,
          invalidated: true,
          items: [],
          pagination: {
            current: -1,
            totalPages: 1,
          },
        },
      });
    case FETCHING_USER_MANAGEMENT_USER_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          user: action.payload,
        },
      });
    case FETCHING_INVITATIONS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          loading: true,
          invalidated: true,
        },
      });

    case FETCHING_INVITATIONS_SUCCEDDED:
      var records = action.payload.records;
      var items = [];

      records = records.map((item) => {
        return Object.assign({}, item, {
          ...item,
          resending: false,
          deleting: false,
        });
      });

      if (action.payload.currentPage != 0) {
        items = [...state.invitations.items, ...action.payload.records];
      } else {
        items = action.payload.records;
      }

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          loading: false,
          invalidated: false,
          items: items,
          pagination: {
            ...state.users.pagination,
            current: action.payload.currentPage,
            totalPages: action.payload.totalPages,
          },
        },
      });

    case FETCHING_INVITATIONS_FAILED:
      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          loading: false,
          invalidated: false,
          error: action.payload.error,
          pagination: {
            current: -1,
            totalPages: 1,
          },
        },
      });

    case INVITE_USER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        inviting: true,
        inviteError: null,
      });

    case INIVITE_USER_SUCCEDDED:

    var updatedItems = [...state.invitations.items, action.payload]; 

      return Object.assign({}, state, {
        ...state,
        inviting: false,
        invitations: {
          ...state.invitations,
          items: updatedItems,
        },
      });

    case INIVITE_USER_FAILED:
      return Object.assign({}, state, {
        ...state,
        inviting: false,
        inviteError: action.payload,
      });
    case INVALIDATE_ERROR_MESSAGE:
      return Object.assign({}, state, {
        ...state,
        inviteError: null,
      });
    case SELECT_USER:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          user: action.payload,
        },
      });
    case INVALIDATE_USER:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          user: {},
        },
      });

    case UPDATE_USER_ACTIVATION:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          updating: true,
        },
      });
    case UPDATE_USER_ACTIVATION_SUCCEDDED:
      var id = action.payload.id;

      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          updating: false,
          user: action.payload,
          items: state.users.items.map((user) => {
            if (user.id != id) {
              return user;
            }

            return {
              ...user,
              enabled: action.payload.enabled,
            };
          }),
        },
        items: state.items.map((user) => {
          if (user.id !== id) {
            return user;
          }
          return {
            ...user,
            enabled: action.payload.enabled,
          };
        }),
      });
    case UPDATE_USER_ACTIVATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          updating: false,
        },
      });

    case UPDATE_USER_ACCESS:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          updatingAccess: true,
        },
      });

    case UPDATE_USER_ACCESS_SUCCEEDED:
      var id = action.payload.id;
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          user: action.payload,
          items: state.users.items.map((user, index) => {
            if (user.id != id) {
              return user;
            }

            return {
              ...user,
              ...action.payload,
            };
          }),
        },
      });

    case UPDATE_USER_ACCESS_FAILED:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          updatingAccess: false,
        },
      });

    case UPDATE_USER_ROLES:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          updating: true,
        },
      });
  
    case UPDATE_USER_ROLES_SUCCEEDED:
      var id = action.payload.id;
      const { roles } = action.payload.id;
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          user: {
            ...state.users.user,
            ...action.payload,
          },
          updating: false,
          items: state.users.items.map((user, index) => {
            if (user.id != id) {
              return user;
            }

            return {
              ...user,
              roles,
            };
          }),
        },
      });

    case UPDATE_USER_ROLES_FAILED:
      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          updating: false,
        },
      });

    case RESEND_USER_INVITATION:
      var invitationId = action.payload;

      var invitations = state.invitations.items.map((invitation) => {
        if (invitation.id == invitationId) {
          return {
            ...invitation,
            resending: true,
          };
        } else {
          return invitation;
        }
      });
      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          items: invitations,
        },
      });
    case RESEND_USER_INVITATION_SUCCEDDED:
      var invitationId = action.payload;

      var invitations = state.invitations.items.map((invitation) => {
        if (invitation.id == invitationId) {
          return {
            ...invitation,
            resending: false,
          };
        } else {
          return invitation;
        }
      });
      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          items: invitations,
        },
      });
    case RESEND_USER_INVITATION_FAILED:
      var invitationId = action.payload.id;

      var invitations = state.invitations.items.map((invitation) => {
        if (invitation.id == invitationId) {
          return {
            ...invitation,
            resending: false,
          };
        } else {
          return invitation;
        }
      });
      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          items: invitations,
        },
      });

    case DELETE_USER_INVITATION:
      var invitationId = action.payload;

      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          deleting: true,
        },
      });
    case DELETE_USER_INVITATION_SUCCEDDED:
      var id = action.payload;
      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          items: state.invitations.items.filter((user, index) => {
            return user.id != id;
          }),
          deleting: false,
        },
        items: state.items.filter((user) => user.id !== id),
      });
    case DELETE_USER_INVITATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          deleting: false,
        },
      });
    case INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_REQUEST: {
      const { page } = action.payload;

      let items = state.download.items;

      if (page === 0) {
        items = [];
      }

      return Object.assign({}, state, {
        ...state,
        download: {
          downloading: true,
          downloaded: false,
          items: items,
          error: null,
        },
      });
    }

    case INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_SUCCEDDED: {
      let result = action.payload;

      var items = [];
      if (result.currentPage === 0) {
        items = result.records;
      } else {
        items = [...state.download.items, ...result.records];
      }

      var downloading = result.currentPage + 1 < result.totalPages;

      return Object.assign({}, state, {
        ...state,
        download: {
          downloading: downloading,
          downloaded: !downloading,
          items: items,
          pagination: {
            currentPage: result.currentPage,
            totalPages: result.totalPages,
            recordsPerPage: result.recordsPerPage,
            totalRecordsCount: result.totalRecordsCount,
          },
          error: null,
        },
      });
    }

    case INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_FAILED: {
      return Object.assign({}, state, {
        ...state,
        download: {
          downloading: false,
          downloaded: false,
          items: [],
          pagination: {
            ...paginationState,
          },
          error: action.payload,
        },
      });
    }

    case FETCHING_USER_GROUPS_FOR_USER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        userGroups: {
          ...state.userGroups,
          loading: true,
          invalidated: true,
        },
      });

    case FETCHING_USER_GROUPS_FOR_USER_SUCCEEDED:
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage != 0) {
        items = [...state.userGroups.items, ...action.payload.records];
      } else {
        items = action.payload.records;
      }

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return Object.assign({}, state, {
        ...state,
        userGroups: {
          ...state.userGroups,
          loading: false,
          invalidated: false,
          items: items,
          pagination: {
            ...state.userGroups.pagination,
            current: action.payload.currentPage,
            totalPages: action.payload.totalPages,
          },
        },
      });

    case FETCHING_USER_GROUPS_FOR_USER_FAILED:
      return Object.assign({}, state, {
        ...state,
        userGroups: {
          ...state.userGroups,
          loading: false,
          invalidated: false,
          error: action.payload.error,
          pagination: {
            current: -1,
            totalPages: 1,
          },
        },
      });

    case INVALIDATE_USER_GROUPS:
      return Object.assign({}, state, {
        ...state,
        userGroups: {
          loading: false,
          invalidated: true,
          items: [],
          pagination: {
            current: -1,
            totalPages: 1,
          },
        },
      });

    default:
      return state;
  }
}

export { userManagementReducer };
